import { cloneDeep } from 'lodash-es'
import React, { useState, useEffect } from 'react'
import { Table, Panel, IconButton, Icon, Grid, Row, Col, Checkbox, Message } from 'rsuite'
import { updateAttendanceMulti } from '../../redux/actions/multiReview'
import { doneLoading, startLoading } from '../../utils/loading'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

export default function AttendanceRecordWidget({ schema, isSingle }) {
  const { Column, HeaderCell, Cell } = Table

  const [formSchema, setFormSchema] = useState(schema)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleCallService = async (request) => {
    startLoading()

    try {
      console.log('request', request)
      const response = await updateAttendanceMulti(request)
      console.log('response', response)
      setFormSchema(response)
      // let response = cloneDeep(formSchema)
      // for (let index = 0; index < response.values.length; index++) {
      //   if (response.values[index].id == id) {
      //     response.values[index].isAttendMeeting = status
      //   }
      // }
      // console.log('response', JSON.stringify(response))
      // setFormSchema(response)
    } catch (e) {
      console.log('e', e)
    }

    doneLoading()
  }

  const handleAction = (rowData, isAttend) => {
    let idLest = sessionStorage.getItem('mutiReview')
    const request = {
      id: isSingle ? projectId : idLest,
      projectReviewerIds: rowData.ids,
      isAttendMeeting: isAttend,
    }

    handleCallService(request)
  }

  const ImageCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <Grid fluid>
        <Icon icon="user" size="2x" style={{ marginTop: 10 }} />
        {/* <Row>
          <Col
            lg={12}
            style={{
              width: 40,
              height: 40,
              borderRadius: 20,
              marginTop: 2,
            }}
          >
            <div style={{ marginTop: 6, marginLeft: 8 }}>
              <img src={rowData[dataKey]} width="35" />
            </div>
          </Col>
        </Row> */}
      </Grid>
    </Cell>
  )

  return (
    <Panel header={formSchema.header}>
      <Table
        wordWrap
        height={400}
        data={formSchema.values || []}
        autoHeight={formSchema.values?.length <= 5}
      >
        <Column width={60} align="center">
          <HeaderCell>
            <span></span>
          </HeaderCell>
          <ImageCell dataKey="avartar" />
        </Column>

        <Column minWidth={250} flexGrow={1}>
          <HeaderCell>
            <span>ชื่อผู้ทรงคุณวุฒิ</span>
          </HeaderCell>
          <Cell dataKey="name" />
        </Column>
        <Column width={200} align="center">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData) => {
              return rowData.isAttendMeeting ? (
                <IconButton
                  style={{ width: '180px' }}
                  icon={<Icon icon={'check-circle'} style={{ color: '#2DA888' }} />}
                  onClick={() => {
                    handleAction(rowData, false)
                  }}
                >
                  เข้าร่วมการประชุม
                </IconButton>
              ) : (
                <IconButton
                  style={{ width: '180px' }}
                  icon={<Icon icon={'close-circle'} />}
                  onClick={() => {
                    handleAction(rowData, true)
                  }}
                >
                  ไม่เข้าร่วมการประชุม
                </IconButton>
              )
            }}
          </Cell>
        </Column>
      </Table>
    </Panel>
  )
}
